var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"stacking-layers-container text-center",style:(_vm.containerStyles)},[_c('div',{staticClass:"stacking-layers-container-layer-1",style:(_vm.layerOneStyles)},[_vm._t("layer-1")],2),_c('div',{staticClass:"stacking-layers-container-layer-2",style:(_vm.layerTwoStyles)},[_vm._t("layer-2")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }